import { useQuery } from "@tanstack/react-query"

import {
  getNotificationEventMeta,
  getNotificationEvents,
  updateNotificationEvent,
} from "api/notificationEventApi"
import { useEditResource, usePaginatedResource } from "./useCrudResource"

export const NOTIFICATION_EVENT_QUERY_KEY = "notification-events"

export const useNotificationEvents = (params = {}, enabled = true) =>
  usePaginatedResource(
    NOTIFICATION_EVENT_QUERY_KEY,
    getNotificationEvents,
    params,
    enabled
  )

export const useNotificationEventMeta = (enabled = true) =>
  useQuery({
    queryKey: [NOTIFICATION_EVENT_QUERY_KEY, "meta"],
    queryFn: getNotificationEventMeta,
    enabled,
    staleTime: 10 * 60 * 1000,
  })

export const useUpdateNotificationEvent = () =>
  useEditResource(updateNotificationEvent, NOTIFICATION_EVENT_QUERY_KEY)
